<template>
    <div>
        <div style="min-width: 400px; width: 40vw; margin: auto; margin-top: 100px;" class="border-box">
            <div v-if="!succeedRequestResetPasswordCommandV1">
                <div>
                    <h3 class="fg-color-blue">Reset password request</h3>
                    <br />

                    <div class="form-group">
                        <label for="Email">Email:</label>
                        <input v-model="email" type="email" class="form-control">
                        <ValidationError context="Email" :errors="validationErrors"></ValidationError>
                    </div>
                    <br />

                    <button v-if="!invokingRequestResetPasswordCommandV1" @click="invokeRequestResetPasswordCommandV1" type="button" class="btn btn-primary btn-lg btn-block">Request</button>
                    <button v-else type="button" class="btn btn-primary btn-lg btn-block" disabled>Requesting...</button>
                </div>

                <br />

                <span>
                    Already have an account? <a href="/#/signin">Sign-in</a>
                </span>
            </div>

            <div v-else>
                <h1>Your request was sent</h1>
                <h4>
                    If you have an active account in TransparentChoice then you will get an email with reset password link valid 24h.
                    Please use this link to set a new password.
                </h4>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, onMounted } from 'vue'
    import ValidationError from '@common/Components/ValidationError.vue'
    import { useRequestResetPasswordCommandV1 } from '@Organizations/Users/commands-vue-composables'

    const email = ref('')

    const {
        invokeRequestResetPasswordCommandV1,
        invokingRequestResetPasswordCommandV1,
        succeedRequestResetPasswordCommandV1,
        validationErrors
    } = useRequestResetPasswordCommandV1(email)

    onMounted(() =>
    {
        document.title = 'Request reset password'
    })
</script>
